<div class="flex flex-col gap-8">
  <span class="text-[18px] font-bold">Cumplimiento Orden HAP/796/2025</span>

  <div class="flex flex-col gap-8">
    <div class="flex flex-col gap-4">
      <div class="flex gap-3 items-start">
        <input
          *ngIf="reviewMode && !readonlyReview"
          type="checkbox"
          class="mt-1"
          [checked]="reviewFields.isFieldMarked('dataSovereigntyCheck')"
          (change)="reviewFields.toggleField('dataSovereigntyCheck')" />
        <div class="flex flex-col gap-2">
          <div class="flex items-start gap-2">
            <span class="text-[14px] text-neutral-dark">Soberania del dato protegida</span>
            <app-tooltip
              *ngIf="
                reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('dataSovereigntyCheck')
              "
              class="-mt-2"
              [description]="previousReviewText('dataSovereigntyCheck')"
              tipeIcon="info"></app-tooltip>
          </div>
          <span class="text-[16px] font-regular">
            {{ hapData?.dataSovereigntyCheck ? 'Si' : 'No' }}
          </span>
        </div>
      </div>

      <div
        *ngIf="hapData?.dataSovereigntyCheck"
        class="flex gap-3 items-start">
        <input
          *ngIf="reviewMode && !readonlyReview"
          type="checkbox"
          class="mt-1"
          [checked]="reviewFields.isFieldMarked('dataSovereignty')"
          (change)="reviewFields.toggleField('dataSovereignty')" />
        <div class="flex flex-col gap-2">
          <div class="flex items-start gap-2">
            <span class="text-[14px] text-neutral-dark">Descripcion</span>
            <app-tooltip
              *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('dataSovereignty')"
              class="-mt-2"
              [description]="previousReviewText('dataSovereignty')"
              tipeIcon="info"></app-tooltip>
          </div>
          <span class="text-[16px] font-regular whitespace-pre-line">
            {{ hapData?.dataSovereignty || '-' }}
          </span>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <div class="flex gap-3 items-start">
        <input
          *ngIf="reviewMode && !readonlyReview"
          type="checkbox"
          class="mt-1"
          [checked]="reviewFields.isFieldMarked('equityAndAccessCheck')"
          (change)="reviewFields.toggleField('equityAndAccessCheck')" />
        <div class="flex flex-col gap-2">
          <div class="flex items-start gap-2">
            <span class="text-[14px] text-neutral-dark">Equidad y acceso universal verificado</span>
            <app-tooltip
              *ngIf="
                reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('equityAndAccessCheck')
              "
              class="-mt-2"
              [description]="previousReviewText('equityAndAccessCheck')"
              tipeIcon="info"></app-tooltip>
          </div>
          <span class="text-[16px] font-regular">
            {{ hapData?.equityAndAccessCheck ? 'Si' : 'No' }}
          </span>
        </div>
      </div>

      <div
        *ngIf="hapData?.equityAndAccessCheck"
        class="flex gap-3 items-start">
        <input
          *ngIf="reviewMode && !readonlyReview"
          type="checkbox"
          class="mt-1"
          [checked]="reviewFields.isFieldMarked('equityAndAccess')"
          (change)="reviewFields.toggleField('equityAndAccess')" />
        <div class="flex flex-col gap-2">
          <div class="flex items-start gap-2">
            <span class="text-[14px] text-neutral-dark">Descripcion</span>
            <app-tooltip
              *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('equityAndAccess')"
              class="-mt-2"
              [description]="previousReviewText('equityAndAccess')"
              tipeIcon="info"></app-tooltip>
          </div>
          <span class="text-[16px] font-regular whitespace-pre-line">
            {{ hapData?.equityAndAccess || '-' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
